import { render, staticRenderFns } from "./ZDMReportsTabCustom.vue?vue&type=template&id=5639cac4&scoped=true&"
import script from "./ZDMReportsTabCustom.vue?vue&type=script&lang=js&"
export * from "./ZDMReportsTabCustom.vue?vue&type=script&lang=js&"
import style0 from "./ZDMReportsTabCustom.vue?vue&type=style&index=0&id=5639cac4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5639cac4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
